import Card from './src'

Card.install = Vue => {
  Vue.component(Card.name, Card)
}

export default Card
